import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loginStatus: false,
    name: '',
    nickname: '',
    avatar: '',
    data: null
  },
  mutations: {
    setLoginStatus(state, val) {
      state.loginStatus = val
    },
    setUserInfo(state, user) {
      state.name = user.name || ''
      state.nickname = user.nickname || ''
      state.avatar = user.avatar || ''
      state.data = user
    },
    clearUserInfo(state) {
      state.loginStatus = false
      state.name = ''
      state.nickname = ''
      state.avatar = ''
      state.data = null
    }
  },
  actions: {},
  modules: {}
})
